$mobile-header-breakpoint: 640px;

:export {
  mobileHeaderBreakpoint: $mobile-header-breakpoint - 1;
}
